module.exports = __webpack_public_path__ + "static/media/cordova.aa5aebb4.svg";